<script setup lang="ts">
import { useSubmissionJobs } from "~/stores/useSubmissionJobs.store";

const { submissionJobs } = useSubmissionJobs();
</script>

<template>
  <div>
    <BaseSheetComponent
      v-for="job in submissionJobs"
      :key="job.id"
      :controller="job.sheetController"
      :z-index-override="99999"
    >
      <template #content>
        <div class="p-4">
          <UploadStudentSubmissionDialog
            :job="job"
            @close="job.sheetController.close()"
          />
        </div>
      </template>
    </BaseSheetComponent>
  </div>
</template>

<style scoped></style>
